import { render, staticRenderFns } from "./ShakingHands.vue?vue&type=template&id=5aa1c256"
import script from "./ShakingHands.vue?vue&type=script&lang=js"
export * from "./ShakingHands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports